var constants = {
  ADD_FAVORITE: 'ADD_FAVORITE',
  REMOVE_FAVORITE: 'REMOVE_FAVORITE',
  LOAD_FAVORITES: 'LOAD_FAVORITES',

  RECEIVE_ADDED_FAVORITE: 'RECEIVE_ADDED_FAVORITE',
  RECEIVE_REMOVED_FAVORITE: 'RECEIVE_REMOVED_FAVORITE',

  RECEIVE_ALL_FAVORITES: 'RECEIVE_ALL_FAVORITES',
  UPDATE_FAVORITES: 'UPDATE_FAVORITES',

  LOGIN_REQUIRED: 'LOGIN_REQUIRED',
  LOGIN_SUCCESSFUL: 'LOGIN_SUCCESSFUL'
};

module.exports = constants;



// WEBPACK FOOTER //
// ./constants/global.js